export default "__VITE_ASSET__CQUuMfKG__"